import React, { useEffect, useContext, useState } from "react";
import { DropDown, Input, SwitchButton, CardInput, TableCober } from "../controls";
import { DataContext } from '../../data/DataContext';
import { IconVisaMastercard } from '../../svg/index';
import http from "../../../../services/http";
import { endPoints } from "../../../../utils/constanst";
import { buildTarficacionData, buildDetTable, getResumen } from '../../services/help';
import Modal from "react-modal";

const Step5 = () => {
    const { VivirSeguro, setVivirSeguro, changeHandler } = useContext(DataContext);
    const [tableCober, setTableCober] = useState([]);
    const optionsUsd = { style: 'currency', currency: 'USD' };
    const numberFormatUsd = new Intl.NumberFormat('en-US', optionsUsd);
    const [loading, setLoading] = useState(false);
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    let isAmex = false;

    const cardHandler = cardData => {
        isAmex = String(cardData.numeroTarjeta).substring(0, 2) === '34' || String(cardData.numeroTarjeta).substring(0, 2) === '37';
        setVivirSeguro({ ...VivirSeguro, isAmex: isAmex, numeroTarjeta: cardData.numeroTarjeta });
    }

    const onChangeSumaAsegurada = (event) => {
        setVivirSeguro({ ...VivirSeguro, planSeguro: event.target.desc, suma: event.target.value });
    }
    const onChangeCuotas = (event) => {
        setVivirSeguro({ ...VivirSeguro, descCuota: event.target.desc, cuota: event.target.value });
    }

    const Tarificar = async () => {
        setLoading(true);
        await new Promise(() => {
            http(endPoints.coverages(VivirSeguro.idPlan))
                .get()
                .then((data) => {
                    VivirSeguro.setCatalogos({ coberturas: data.coverages });
                    const dat = buildTarficacionData(data.coverages, VivirSeguro);

                    new Promise(() => {
                        http(endPoints.tarificar(VivirSeguro.idPlan)).post(dat)
                            .then((r) => {
                                setLoading(false);
                                //setTableCober(buildDetTable(VivirSeguro.catalogos.coberturas, r.rates));
                                VivirSeguro.setCatalogos({ rates: r.rates });
                               
                            })
                            .catch((error) => {
                                setLoading(false);
                                handleShow();
                                setVivirSeguro({ ...VivirSeguro, mensaje: error, montoPagar:0, montoPagarVisualizar:0, montoCuota:0});
                                
                            });
                    })
                }).catch((error) => {
                    setLoading(false);
                });
        });
    }

    const buildResumen = () => {
        const prima = getResumen(VivirSeguro.catalogos.rates);
        setVivirSeguro({ ...VivirSeguro, montoPagarVisualizar: numberFormatUsd.format(Number.parseFloat(prima).toFixed(2)), montoPagar: prima });
    };

    const calcCuota = () => {
        if (VivirSeguro.cuota !== '' && VivirSeguro.cuota !== 0 && VivirSeguro.montoPagar !== 0 && VivirSeguro.montoPagar !== '') {
            let mCuota = VivirSeguro.montoPagar / VivirSeguro.cuota;
            setVivirSeguro({...VivirSeguro, montoCuota: numberFormatUsd.format(Number.parseFloat(mCuota).toFixed(2))});
        }
    };


    useEffect(() => {
        if (VivirSeguro.suma !== '' && VivirSeguro.suma !== 0)
            Tarificar();
    }, [VivirSeguro.suma]);

    useEffect(() => {
        setTableCober(buildDetTable(VivirSeguro.catalogos.coberturas, VivirSeguro.catalogos.rates));
        buildResumen();
    }, [VivirSeguro.catalogos.rates]);

    useEffect(() => {
        calcCuota();
    }, [VivirSeguro.cuota, VivirSeguro.montoPagar]);


    return (
        <div className="step">
            <div className="step-container-vivirseguro">
                <div>
                    <span className="title2">Eleg&iacute; el mejor plan para vos</span>
                </div>
                <div>
                    <span className="title3">Lo que var&iacute;a por plan, es la cantidad de dinero que recibiran tus beneficiarios</span>
                </div>
                <DropDown label="Plan" dataProvider={VivirSeguro.catalogos.sumaAsegurada} valueSelect={VivirSeguro.suma} fieldSelect="suma" field="suma" isRequired={true}  onChangeSelect={onChangeSumaAsegurada} />
                <TableCober array={tableCober} />
                <Input labelLeft="Dólares ($)" readOnly={true} label="Monto a pagar" value={VivirSeguro.montoPagarVisualizar} field="montoPagarVisualizar" onChange={changeHandler} ></Input>
                <DropDown label="¿En cuantas cuotas lo quieres pagar?" dataProvider={VivirSeguro.catalogos.fees} valueSelect={VivirSeguro.cuota} fieldSelect="cuota" field="cuota" isRequired={true}  onChangeSelect={onChangeCuotas} />
                <Input labelLeft="Dólares ($)" readOnly={true} label="Monto a pagar"  labelInfo="El monto a pagar está calculado según la cantidad de cuotas que usted seleccionó para el pago del costo total del seguro" value={VivirSeguro.montoCuota} field="montoCuota" onChange={changeHandler} ></Input>
                <SwitchButton label="Opción de pago" value={VivirSeguro.esTelepago} si="Telepago" no="En línea" field="esTelepago" onClick={(value) => setVivirSeguro({ ...VivirSeguro, esTelepago: value })} />
                <SwitchButton label="Opción de entrega" labelInfo="*Delivery solo en ciudad de Managua" value={VivirSeguro.esDelivery} si="Delivery" no="En sucursal" onClick={(value) => setVivirSeguro({ ...VivirSeguro, esDelivery: value })} />
                
                {VivirSeguro.esTelepago == false && <div className="container-pay mt-20">
                    <div className="mt-15 mb-20">
                        <span className="title2 mb-15">
                            Realizá tu pago aquí  </span>
                    </div>
                    <Input label="Nombre tarjeta" placeholder="Ejemplo: Juan Pérez" value={VivirSeguro.nombreTarjeta} field="nombreTarjeta" onChange={changeHandler} ></Input>
                    <CardInput
                        placeholder='0000-0000-0000-0000'
                        label='Numero de tarjeta'
                        field='numeroTarjeta'
                        title='Tarjeta inválido'
                        value={VivirSeguro.numeroTarjeta}
                        type='maskInput'
                        onChange={cardHandler}
                        icon={<IconVisaMastercard />}
                    ></CardInput>
                    <div className="col">
                        <Input label="Expiración" placeholder="MM/YY"
                            classNameInput="input-field-col" value={VivirSeguro.expiracionTarjeta} field="expiracionTarjeta"
                            onChange={changeHandler}
                            type='mask'
                            mask='99/99'
                            title='Fecha invalida'
                        ></Input>

                        {VivirSeguro.isAmex && <Input type="mask" label="CVV" value={VivirSeguro.cvvTarjeta} field="cvvTarjeta" onChange={changeHandler} placeholder="0000" mask='9999' title='Código inválido' pattern="\d\d\d\d"  ></Input>}
                        {!VivirSeguro.isAmex && <Input type="mask" label="CVV" value={VivirSeguro.cvvTarjeta} field="cvvTarjeta" onChange={changeHandler} placeholder="000" mask='999' title='Código inválido' pattern="\d\d\d"  ></Input>}

                    </div>

                </div>}
                
            </div>
            <Modal className="modal" isOpen={loading} show={loading} ariaHideApp={false}>
                <div className="dialog-center-content">
                    <p className="text-center">Cargando...</p>
                </div>
            </Modal>
            <Modal className="modal" isOpen={show} show={show} ariaHideApp={false}>
                <div className="modal-title">
                    <span className="txt-title-modal">Información</span>
                </div>
                <div className="modal-body-info">
                    {VivirSeguro.mensaje}
                </div>
                <div className="modal-footer">
                    <button className="modal-btn-close" onClick={handleClose}>Cerrar</button>
                </div>
            </Modal>
        </div>
    );
}

export default Step5;